import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { UNASSIGNED_RESULTS_COUNT_QUERY_KEY } from "features/results/hooks/useUnassignedResultsCount";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useAssignCommonResult = () => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Failed to assign common result");

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ resultId, patientId }) => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/healthlink/common/message/${resultId}/patient/${patientId}`
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Common result assigned successfully!");
      queryClient.invalidateQueries({ queryKey: ["staffCommonResults"] });
      queryClient.invalidateQueries({ queryKey: ["unmatchedStaffCommonResults"] });
      // The badge and the switch's count both read this; an assign is exactly the
      // event that changes it.
      queryClient.invalidateQueries({
        queryKey: [UNASSIGNED_RESULTS_COUNT_QUERY_KEY],
      });
    },
    onError: handleNetworkError,
    // Show only this specific toast — opt out of the global MutationCache handler.
    meta: { skipGlobalError: true },
  });
};
